module.exports = __webpack_public_path__ + "static/img/operateVip.2ae2529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateVip.png
// module id = Ye4g
// module chunks = 1